import React from 'react';
import './index.scss';

export default function SeoRelatedSearch(props) {
  const { vsRelatedKeywordsList = [], i18n } = props;
  const renderLink = (item, index) => {
    return (
      <a
        data-domdot="id:10556"
        className="dot-qr"
        key={index}
        style={{
          color: '#f60',
        }}
        href={item.hrefObject.url}
      >
        {item.hrefObject.name}
      </a>
    );
  };
  const renderTitle = index => {
    if (index === 0) return i18n['seoRelatedSearch_title'];
    if (index === 1) return 'China';
    return i18n['seoSimilarProducts_title_text'];
  };
  return vsRelatedKeywordsList.map((keywords, keysIndex) => (
    <div
      className="scc-wrapper detail-module module-seoRelatedSearch"
      key={keysIndex}
      data-spm="sechated10"
    >
      <div className="dotted-top cross-link" id="J-seo-cross-link">
        <div className="more-cross J-seo-more-cross">
          <div className="cross">
            <h3 className="title">{renderTitle(keysIndex)}</h3>
            <div className="links">
              {keywords.map((items, keyIndex) => (
                <div className="items util-clearfix" key={keyIndex}>
                  {items
                    .slice(0, 3)
                    .map((item, index) =>
                      renderLink(item, keysIndex * keyIndex + index),
                    )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  ));
}
